export const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string) ?? '/',
  mode: import.meta.env.MODE,
  dev: import.meta.env.DEV,
};
